import React from 'react';
import Routes from './routes';
import Toolbar from './components/Toolbar';

export default () => {
  return (
    <>
      <Toolbar />
      <Routes />
    </>
  );
};
